import * as types from 'store/modules/stdreq/mutation-types'
import stdreq from 'api/stdreq'
import swal from 'sweetalert'
import stdreqLabels from 'assets/labels/stdreq'
import { stdreqColumns } from 'assets/columns/stdreq'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    labels: stdreqLabels,
    columns: stdreqColumns(),
    index: {
      treqest1: {
        numreqst: ''
      },
      treqest2: {
        total: 0,
        rows: []
      },
      detail: {
        total: 0,
        rows: []
      }
    }
  },
  getters: {
    [types.GET_STDREQ_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_STDREQ_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_STDREQ_LABELS] (state) {
      return state.labels
    },
    [types.GET_STDREQ_INDEX] (state) {
      return state.index
    }
  },
  mutations: {
    [types.SET_STDREQ_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_STDREQ_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_STDREQ_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_STDREQ_INDEX] (state, data) {
      state.index = data
    }
  },
  actions: {
    [types.TOGGLE_STDREQ_PAGE] ({ commit }, page) {
      let indexDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
      }
      commit(types.SET_STDREQ_INDEX_DISP, indexDisp)
    },
    [types.RECEIVED_STDREQ_COLUMNS_LABELS] ({ commit }) {
      stdreq.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_STDREQ_COLUMNS, data.labels)
          commit(types.SET_STDREQ_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_STDREQ_INDEX] ({ commit }, searchParams) {
      stdreq.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_STDREQ_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/stdreq/index.js